(function () {
  if (window.__coluluPdpCommonPurchaseBound) return;
  window.__coluluPdpCommonPurchaseBound = true;

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-pdp-manual-quantity] button[name="minus"], [data-pdp-manual-quantity] button[name="plus"]');
    if (!button) return;

    const control = button.closest('[data-pdp-manual-quantity]');
    // Shopify's native component already handled this bubbling click.
    const NativeQuantity = window.customElements?.get('quantity-input');
    if (NativeQuantity && control instanceof NativeQuantity) return;
    const input = control && control.querySelector('input[name="quantity"]');
    if (!input) return;

    event.preventDefault();
    if (button.name === 'plus') input.stepUp();
    else input.stepDown();
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();

(() => {
  if (window.__coluluPdpAddonPlacementBound) return;
  window.__coluluPdpAddonPlacementBound = true;

  const optionRootSelector = '.ef__product-option-root';
  const purchaseModuleSelector = '[data-pdp-purchase-module]';

  const readIds = (values) => [...new Set(values.map((value) => String(value || '').trim()).filter(Boolean))];
  const optionRootVariantIds = (optionRoot) => readIds((optionRoot.dataset.variantIds || '').split(','));
  const moduleVariantIds = (purchaseModule) => readIds(
    [...purchaseModule.querySelectorAll('select[name="id"] option')].map((option) => option.value)
  );

  const findPurchaseModule = (optionRoot) => {
    const modules = [...document.querySelectorAll(purchaseModuleSelector)]
      .filter((module) => module.querySelector('[data-colulu-addon-slot]'));
    if (!modules.length) return null;

    const variantIds = optionRootVariantIds(optionRoot);
    if (variantIds.length) {
      const matched = modules.find((module) => {
        const candidates = moduleVariantIds(module);
        return candidates.some((id) => variantIds.includes(id));
      });
      if (matched) return matched;
    }

    return modules.length === 1 ? modules[0] : null;
  };

  const placeOptionRoot = (optionRoot) => {
    const purchaseModule = findPurchaseModule(optionRoot);
    const slot = purchaseModule?.querySelector('[data-colulu-addon-slot]');
    if (!slot) return false;

    if (optionRoot.parentElement !== slot) slot.append(optionRoot);
    optionRoot.dataset.coluluPurchaseOption = 'true';
    const fallback = purchaseModule.querySelector('[data-product-type-fallback]');
    if (fallback) fallback.hidden = true;
    return true;
  };

  const syncOptionRoots = () => {
    document.querySelectorAll(optionRootSelector).forEach(placeOptionRoot);
  };

  let placementFrame = 0;
  const scheduleSync = () => {
    if (placementFrame) return;
    placementFrame = window.requestAnimationFrame(() => {
      placementFrame = 0;
      syncOptionRoots();
    });
  };

  const initialize = () => {
    syncOptionRoots();
    new MutationObserver(scheduleSync).observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();

(() => {
  if (window.__coluluSharedPurchaseOptionsBound) return;
  window.__coluluSharedPurchaseOptionsBound = true;

  const parseVariants = (root) => {
    try {
      return JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
    } catch (error) {
      console.warn('Colulu shared purchase: variant JSON could not be parsed.', error);
      return [];
    }
  };

  const getSelections = (root) => [...root.querySelectorAll('[data-colulu-purchase-option-group]')]
    .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
    .map((group) => group.querySelector('[data-colulu-purchase-option-value]:checked')?.value || '');

  const syncSelectedLabels = (root) => {
    root.querySelectorAll('[data-colulu-purchase-option-group]').forEach((group) => {
      const checked = group.querySelector('[data-colulu-purchase-option-value]:checked');
      const label = group.querySelector('[data-selected-option]');
      if (label && checked) label.textContent = checked.value;
      group.querySelectorAll('.colulu-purchase__option-pill').forEach((pill) => {
        const selected = pill.querySelector('[data-colulu-purchase-option-value]')?.checked === true;
        pill.classList.toggle('is-selected', selected);
      });
    });
  };

  const syncValueAvailability = (root, variants, selections) => {
    root.querySelectorAll('[data-colulu-purchase-option-value]').forEach((input) => {
      const position = Number(input.dataset.optionPosition) - 1;
      const candidate = selections.map((selected, index) => index === position ? input.value : selected);
      const possible = variants.some((variant) => variant.available && variant.options.every((value, index) => index > position || !candidate[index] || value === candidate[index]));
      const pill = input.closest('.colulu-purchase__option-pill');
      pill?.classList.toggle('is-unavailable', !possible);
      input.setAttribute('aria-disabled', String(!possible));
    });
  };

  const resolveSelectedVariant = (variants, selections, changedPosition = -1) => {
    const exact = variants.find((item) => item.options.every((value, index) => value === selections[index]));
    if (exact && (exact.available || changedPosition < 0)) return exact;
    if (changedPosition < 0) return null;
    // A parent choice (e.g. Lite / Rich) may have a different set of colors.
    // Keep its selected prefix and choose only a real, available Shopify variant.
    return variants.find((item) => item.available && item.options.every((value, index) => index > changedPosition || value === selections[index])) || exact || null;
  };

  const getScope = (root) => root.closest('[data-colulu-section], [data-pdp-price-scope], .page-shell') || document;

  const syncVariantImage = (root, variant) => {
    if (!variant?.featured_media_src) return;
    const scope = getScope(root);
    const image = scope.querySelector([
      '[data-colulu-variant-main-image]',
      '[data-colulu-v2-main-image]',
      '[data-swris-main-image]',
      '[data-lullme-main-image]',
      '[data-air-main-image]',
      '#hugwarmer-main-image',
      '[data-drimug-main-image]',
    ].join(','));
    if (!image) return;
    const responsiveMorbyThumb = scope.querySelector(`[data-morby-color-thumb][data-variant-id="${variant.id}"]`);
    if (responsiveMorbyThumb?.dataset.imageSrcset && responsiveMorbyThumb.dataset.imageSrc) {
      // The MORBY section owns each native variant's responsive image sources.
      image.sizes = responsiveMorbyThumb.dataset.imageSizes;
      image.srcset = responsiveMorbyThumb.dataset.imageSrcset;
      image.src = responsiveMorbyThumb.dataset.imageSrc;
      image.alt = variant.title || image.alt;
      responsiveMorbyThumb.dispatchEvent(new MouseEvent('click', { bubbles: true }));
      return;
    }
    image.src = variant.featured_media_src;
    image.removeAttribute('srcset');
    image.alt = variant.title || image.alt;

    // MORBY exposes every native variant: never overwrite another color's tile.
    const variantThumb = scope.querySelector(`[data-morby-color-thumb][data-variant-id="${variant.id}"]`);
    const firstThumb = variantThumb || scope.querySelector([
      '[data-morby-color-thumb]',
      '[data-swris-color-thumb]',
      '[data-lullme-color-thumb]',
      '[data-hug-color-thumb]',
      '[data-drimug-color-thumb]',
    ].join(','));
    if (firstThumb) {
      const thumbImage = firstThumb.matches('img') ? firstThumb : firstThumb.querySelector('img');
      if (thumbImage) {
        thumbImage.src = variant.featured_media_src;
        thumbImage.removeAttribute('srcset');
        thumbImage.alt = firstThumb.matches('img') ? (variant.title || '') : '';
      }
      firstThumb.dataset.imageSrc = variant.featured_media_src;
      firstThumb.dataset.hugThumb = variant.featured_media_src;
      firstThumb.dataset.gallerySrc = variant.featured_media_src;
      firstThumb.dataset.imageAlt = variant.title || '';
      firstThumb.dataset.galleryAlt = variant.title || '';
      firstThumb.dispatchEvent(new MouseEvent('click', { bubbles: true }));
    }

    if (image.matches('[data-air-main-image]')) {
      image.classList.add('is-variant-product-image');
      const galleryShell = image.closest('.pdp-gallery-shell');
      const thumbnails = [...(galleryShell?.querySelectorAll('.pdp-gallery-thumb') || [])];
      const firstThumbnail = thumbnails[0];
      const firstThumbnailImage = firstThumbnail?.querySelector('img');
      if (firstThumbnailImage) {
        firstThumbnailImage.src = variant.featured_media_src;
        firstThumbnailImage.removeAttribute('srcset');
        firstThumbnailImage.alt = '';
        firstThumbnailImage.classList.add('pdp-image--contain');
      }
      thumbnails.forEach((thumbnail, index) => {
        const selected = index === 0;
        thumbnail.classList.toggle('is-selected', selected);
        thumbnail.setAttribute('aria-selected', String(selected));
        thumbnail.tabIndex = selected ? 0 : -1;
      });
    }
  };

  const syncVariantState = (root, variant) => {
    const scope = getScope(root);
    const priceCents = Number(variant.price);
    scope.querySelectorAll('[data-product-price]').forEach((node) => {
      node.textContent = variant.price_formatted || node.textContent;
      if (Number.isFinite(priceCents)) node.dataset.basePriceCents = String(priceCents);
    });

    scope.querySelectorAll('[data-product-compare]').forEach((node) => {
      const hasCompare = Number(variant.compare_at_price) > priceCents;
      node.textContent = hasCompare ? (variant.compare_at_price_formatted || '') : '';
      node.hidden = !hasCompare;
    });

    const availableLabel = root.dataset.availableLabel || '在庫あり';
    const soldOutLabel = root.dataset.soldOutLabel || '売り切れ';
    scope.querySelectorAll('[data-product-availability]').forEach((node) => {
      node.textContent = variant.available ? availableLabel : soldOutLabel;
    });

    const submit = root.querySelector('[data-product-submit]');
    if (submit) {
      const acknowledgement = root.querySelector('[data-order-acknowledgement]');
      const acknowledged = !acknowledgement || acknowledgement.value !== '';
      const label = submit.querySelector('[data-product-submit-label]') || submit;
      submit.dataset.productAvailable = variant.available ? 'true' : 'false';
      submit.disabled = !variant.available || !acknowledged;
      label.textContent = variant.available ? (root.dataset.addLabel || 'カートに追加する') : soldOutLabel;
    }

    if (Number.isFinite(priceCents)) {
      root.dispatchEvent(new CustomEvent('colulu:base-price-change', {
        bubbles: true,
        detail: { priceCents },
      }));
    }
    root.ownerDocument.dispatchEvent(new CustomEvent('colulu:variant-change', {
      detail: { productId: root.dataset.productId, variant },
    }));
  };

  const initializeRoot = (root) => {
    if (root.dataset.coluluPurchaseOptionsMounted === 'true') return;
    const variants = parseVariants(root);
    const select = root.querySelector('[data-variant-select]');
    if (!variants.length || !select) return;
    root.dataset.coluluPurchaseOptionsMounted = 'true';

    const update = (changedPosition = -1) => {
      const selections = getSelections(root);
      const variant = resolveSelectedVariant(variants, selections, changedPosition);
      if (variant) {
        root.querySelectorAll('[data-colulu-purchase-option-value]').forEach((input) => {
          input.checked = input.value === variant.options[Number(input.dataset.optionPosition) - 1];
        });
      }
      syncSelectedLabels(root);
      syncValueAvailability(root, variants, variant?.options || selections);

      if (!variant) {
        const submit = root.querySelector('[data-product-submit]');
        if (submit) {
          submit.disabled = true;
          submit.dataset.productAvailable = 'false';
          const label = submit.querySelector('[data-product-submit-label]') || submit;
          label.textContent = root.dataset.invalidLabel || '組み合わせを選び直してください';
        }
        return;
      }

      select.value = String(variant.id);
      select.dispatchEvent(new Event('change', { bubbles: true }));
      syncVariantState(root, variant);
      syncVariantImage(root, variant);
    };

    root.addEventListener('change', (event) => {
      if (event.target.matches('[data-colulu-purchase-option-value]')) update(Number(event.target.dataset.optionPosition) - 1);
    });
    root.querySelector('[data-order-acknowledgement]')?.addEventListener('change', () => update());
    update();
  };

  const initialize = (scope = document) => {
    if (scope.matches?.('[data-colulu-purchase-root]')) initializeRoot(scope);
    scope.querySelectorAll?.('[data-colulu-purchase-root]').forEach(initializeRoot);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

(() => {
  if (window.__coluluPdpAddonPriceBound) return;
  window.__coluluPdpAddonPriceBound = true;

  const optionRootSelector = '.ef__product-option-root';

  const getPriceScope = (optionRoot) => (
    optionRoot.closest('[data-colulu-section], [data-pdp-price-scope], .page-shell') || document
  );

  const formatYen = (priceCents) => {
    const amount = Math.round(priceCents / 100);
    return `¥${new Intl.NumberFormat('ja-JP', { maximumFractionDigits: 0 }).format(amount)}`;
  };

  const getBasePriceCents = (scope, optionRoot) => {
    const pricedNode = [...scope.querySelectorAll('[data-product-price]')]
      .find((node) => Number.isFinite(Number(node.dataset.basePriceCents)));

    if (pricedNode) return Number(pricedNode.dataset.basePriceCents);

    const appBasePrice = Number(optionRoot?.dataset.productBasePrice);
    return Number.isFinite(appBasePrice) ? appBasePrice : 0;
  };

  const getSelectedAddonPriceCents = (optionRoot) => (
    [...optionRoot.querySelectorAll('.ef__product-option-input:checked[data-value-price]')]
      .reduce((total, input) => {
        const price = Number(input.dataset.valuePrice);
        return total + (Number.isFinite(price) ? price : 0);
      }, 0)
  );

  const syncOptionPrice = (optionRoot) => {
    if (!optionRoot) return;
    const scope = getPriceScope(optionRoot);
    const basePriceCents = getBasePriceCents(scope, optionRoot);
    const addonPriceCents = getSelectedAddonPriceCents(optionRoot);
    const totalPriceCents = basePriceCents + addonPriceCents;

    scope.querySelectorAll('[data-product-price]').forEach((node) => {
      node.textContent = formatYen(totalPriceCents);
      node.dataset.optionTotalCents = String(addonPriceCents);
    });
  };

  const syncAddedOptionRoots = (node) => {
    if (!(node instanceof Element)) return;
    if (node.matches(optionRootSelector)) syncOptionPrice(node);
    node.querySelectorAll(optionRootSelector).forEach(syncOptionPrice);
  };

  document.addEventListener('change', (event) => {
    const input = event.target.closest(`${optionRootSelector} .ef__product-option-input[data-value-price]`);
    if (!input) return;
    syncOptionPrice(input.closest(optionRootSelector));
  });

  document.addEventListener('colulu:base-price-change', (event) => {
    const scope = event.target.closest?.('[data-colulu-section], [data-pdp-price-scope], .page-shell') || document;
    const priceCents = Number(event.detail?.priceCents);
    if (!Number.isFinite(priceCents)) return;

    scope.querySelectorAll('[data-product-price]').forEach((node) => {
      node.dataset.basePriceCents = String(priceCents);
    });

    const optionRoot = scope.querySelector(optionRootSelector);
    if (optionRoot) syncOptionPrice(optionRoot);
  });

  const initialize = () => {
    document.querySelectorAll(optionRootSelector).forEach(syncOptionPrice);
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => mutation.addedNodes.forEach(syncAddedOptionRoots));
    }).observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
